module.exports = __webpack_public_path__ + "img/13_Gusstechnologe_Foto.3ac7b7f7.jpg";